"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                LightBoxNotificationAria: "Critical message press TAB to read content ",
                MessageAlert: "You have received multiple new messages, Ctrl-F7 to read list",
                MessageBar_CollapseMessages: "",
                MessageBar_ExpandMessages: "{0}",
                MessageCenter_ClearMessages: "Clear all",
                MessageCenter_Header: "Action Center",
                MessageCenter_NoMessages: "There are no messages.",
                MessageCenter_SeeAllLink: "See all",
                MessageCenterNotificationAria: "New messages are in the Action Center. The total number of new messages is: ",
                MessageErrorBarNotificationAria: "Error Message bar text is ",
                MessageInfoBarNotificationAria: "Information Message bar text is ",
                MessageWarningBarNotificationAria: "Warning Message bar text is ",
            }
        });
        /**
         * Framework class for the forms MessageBar control
         */
        var MessageBar = /** @class */ (function (_super) {
            __extends(MessageBar, _super);
            function MessageBar() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                /**
                 * @internal
                 */
                _this.IsInfoToggleVisible = $dyn.computed(function () {
                    return $dyn.length(_this.infoMessages) > 1;
                });
                /**
                 * @internal
                 */
                _this.IsWarningToggleVisible = $dyn.computed(function () {
                    return $dyn.length(_this.warningMessages) > 1;
                });
                /**
                 * @internal
                 */
                _this.IsErrorToggleVisible = $dyn.computed(function () {
                    return $dyn.length(_this.errorMessages) > 1;
                });
                /**
                 * @internal
                 */
                _this.IsVisible = $dyn.computed(function () {
                    return _this.IsViewModeVisible() || _this.IsInfoVisible() || _this.IsWarningVisible() || _this.IsErrorVisible();
                });
                /**
                 * @internal
                 */
                _this.IsInfoVisible = $dyn.computed(function () {
                    return $dyn.length(_this.infoMessages) > 0;
                });
                /**
                 * @internal
                 */
                _this.IsWarningVisible = $dyn.computed(function () {
                    return $dyn.length(_this.warningMessages) > 0;
                });
                /**
                 * @internal
                 */
                _this.IsErrorVisible = $dyn.computed(function () {
                    return $dyn.length(_this.errorMessages) > 0;
                });
                /**
                 * @internal
                 */
                _this.InfoCountText = $dyn.computed(function () {
                    return $dyn.format($dyn.label("MessageBar_ExpandMessages"), $dyn.length(_this.infoMessages));
                });
                /**
                 * @internal
                 */
                _this.WarningCountText = $dyn.computed(function () {
                    return $dyn.format($dyn.label("MessageBar_ExpandMessages"), $dyn.length(_this.warningMessages));
                });
                /**
                 * @internal
                 */
                _this.ErrorCountText = $dyn.computed(function () {
                    return $dyn.format($dyn.label("MessageBar_ExpandMessages"), $dyn.length(_this.errorMessages));
                });
                /**
                 * @internal
                 */
                _this.InfoToggle = function () {
                    _this.InfoExpanded(!$dyn.value(_this.InfoExpanded));
                    if ($dyn.value(_this.InfoExpanded)) {
                        _this.WarningExpanded(false);
                        _this.ErrorExpanded(false);
                    }
                };
                /**
                 * clear all info messages
                 * @internal
                 */
                _this.ClearInfoMessages = function () {
                    if (_this.infoMessages) {
                        // Below code is commented out because we are currently not adding any info messages. We should uncomment this when we start adding info messages to control.
                        // Below line should be uncommented if true is passed in third parameter of self.ProcessMessageList(self.infoMessages, infos, false);
                        // self.ClearMessagesFromControl(messages);
                        _this.infoMessages.clear();
                    }
                    _this.InfoExpanded(false);
                };
                /**
                 * @internal
                 */
                _this.WarningToggle = function () {
                    _this.WarningExpanded(!$dyn.value(_this.WarningExpanded));
                    if ($dyn.value(_this.WarningExpanded)) {
                        _this.InfoExpanded(false);
                        _this.ErrorExpanded(false);
                    }
                };
                /**
                 * clears all warning messages
                 * @internal
                 */
                _this.ClearWarningMessages = function () {
                    if (_this.warningMessages) {
                        var messages = $dyn.value(_this.warningMessages);
                        _this.ClearMessagesFromControl(messages);
                        _this.warningMessages.clear();
                    }
                    _this.WarningExpanded(false);
                };
                _this.ErrorToggle = function () {
                    _this.ErrorExpanded(!$dyn.value(_this.ErrorExpanded));
                    if ($dyn.value(_this.ErrorExpanded)) {
                        _this.InfoExpanded(false);
                        _this.WarningExpanded(false);
                    }
                };
                /**
                 * clears all error messages
                 * @internal
                 */
                _this.ClearErrorMessages = function () {
                    if (_this.errorMessages) {
                        // Below code is commented out because we are currently not adding any error messages. We should uncomment this when we start adding error messages to control.
                        // Below line should be uncommented if true is passed in third parameter of self.ProcessMessageList(self.errorMessages, infos, false);
                        // const messages = $dyn.value(this.errorMessages);
                        // self.ClearMessagesFromControl(messages);
                        _this.errorMessages.clear();
                    }
                    _this.ErrorExpanded(false);
                };
                _this.ClearViewModeMessage = function () {
                    _this.IsViewModeVisible(false);
                };
                return _this;
            }
            MessageBar.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                if (!this.infoMessages) {
                    this.infoMessages = $dyn.observableArray([]);
                }
                if (!this.warningMessages) {
                    this.warningMessages = $dyn.observableArray([]);
                }
                if (!this.errorMessages) {
                    this.errorMessages = $dyn.observableArray([]);
                }
                this.Messages = $dyn.computed(function () {
                    var list = $dyn.value(_this.infoMessages).slice();
                    list = list.concat($dyn.value(_this.warningMessages).slice());
                    list = list.concat($dyn.value(_this.errorMessages).slice());
                    return list;
                });
                this.AllMessages = $dyn.computed(function () {
                    var list = $dyn.value(_this.infoMessages).slice();
                    list = list.concat($dyn.value(_this.warningMessages).slice());
                    list = list.concat($dyn.value(_this.errorMessages).slice());
                    return list;
                });
                this.RemoveMessages = function (event, deleteMessages) {
                    for (var i = 0, len = $dyn.length(deleteMessages); i < len; i++) {
                        var message = deleteMessages[i];
                        _this.RemoveMessage(message.messageId);
                    }
                };
                this.ClearMessages = function () {
                    _this.ClearSystemInfoMessages();
                    _this.ClearSystemWarningMessages();
                    _this.ClearSystemErrorMessages();
                };
                $(document.body).on("clearMessageBarMessages", this.ClearMessages);
                $(document.body).on("removeMessages", this.RemoveMessages);
            };
            MessageBar.prototype.shortcutFocus = function () {
                var firstMessageSection = $(this.element).find(".messageBar:visible").first();
                if (firstMessageSection[0]) {
                    // try to find the buttons
                    var collapseButton = $(firstMessageSection[0]).find(".messageBar-collapseButton[data-dyn-lastvisible='true']");
                    if (collapseButton.length > 0) {
                        $(collapseButton[0]).focus();
                    }
                    else {
                        var closeButton = $(firstMessageSection[0]).find(".messageBar-closeIcon");
                        if (closeButton.length > 0) {
                            $(closeButton[0]).focus();
                        }
                    }
                }
            };
            /**
             * Clears all warning messages which has no specific input controls attached to it.
             * This is a temporary fix until Deliverable 1511094 and 331611 are complete.
             * The server will resend validation messages for data that wasn't fixed so this is safe until we complete Deliverable 1511094 and 331611
             */
            MessageBar.prototype._clearWarningMessagesNotAttachedToInputControls = function () {
                var messages = $dyn.value(this.warningMessages).slice();
                if (messages) {
                    var msg = void 0;
                    var relatedCtrl = void 0;
                    // tslint:disable-next-line: prefer-for-of
                    for (var i = 0; i < messages.length; i++) {
                        msg = messages[i];
                        if (msg && "FindRelatedControl" in msg) {
                            relatedCtrl = msg.FindRelatedControl();
                        }
                        // Deletes when there is no related control or when message is related to List or From as a whole but not tied to any specific input control.
                        if (!relatedCtrl || relatedCtrl.TypeName === "List" || relatedCtrl.TypeName === "Form") {
                            this.RemoveMessage(msg.messageId);
                        }
                    }
                }
            };
            /*
             * clear all none application info messages
             */
            MessageBar.prototype.ClearSystemInfoMessages = function () {
                if (this.infoMessages) {
                    var messagesToKeep = this.MessagesToKeep(this.infoMessages);
                    this.infoMessages.clear();
                    this.AddMessagesToList(this.infoMessages, messagesToKeep);
                }
                this.InfoExpanded(false);
            };
            /*
             * clear all none application warning messages
             */
            MessageBar.prototype.ClearSystemWarningMessages = function () {
                if (this.warningMessages) {
                    var messagesToKeep = this.MessagesToKeep(this.warningMessages);
                    this.warningMessages.clear();
                    this.AddMessagesToList(this.warningMessages, messagesToKeep);
                }
                this.WarningExpanded(false);
            };
            /*
             * clear all none application warning messages
             */
            MessageBar.prototype.ClearSystemErrorMessages = function () {
                if (this.errorMessages) {
                    var messagesToKeep = this.MessagesToKeep(this.errorMessages);
                    this.errorMessages.clear();
                    this.AddMessagesToList(this.errorMessages, messagesToKeep);
                }
                this.ErrorExpanded(false);
            };
            MessageBar.prototype.ClearMessagesFromControl = function (messages) {
                if (messages) {
                    var msg = void 0;
                    var relatedCtrl = void 0;
                    // tslint:disable-next-line: prefer-for-of
                    for (var i = 0; i < messages.length; i++) {
                        msg = messages[i];
                        if (msg && "FindRelatedControl" in msg) {
                            relatedCtrl = msg.FindRelatedControl();
                        }
                        if (relatedCtrl && $dyn.messaging.controlCanHaveMessages(relatedCtrl) && msg.messageId) {
                            var inReactGrid = relatedCtrl.isInGrid && relatedCtrl.isInGrid() && relatedCtrl.Root && relatedCtrl.Root.UseReactGrid();
                            // If in react grid keep message on control until control is no longer invalid
                            if (!inReactGrid) {
                                relatedCtrl.removeMessageFromControl(msg.messageId);
                            }
                        }
                    }
                }
            };
            MessageBar.prototype._updateControl = function (controlMessage) {
                /// If the message has the context of the control the warning orginated from,
                /// update that control's message collection and its' status area
                if ("FindRelatedControl" in controlMessage) {
                    var relatedControl = controlMessage.FindRelatedControl();
                    // if related control is defined and HasMessages observable is defined
                    if (relatedControl && $dyn.messaging.controlCanHaveMessages(relatedControl)) {
                        // Add message to control's message list
                        if ($dyn.messageManager.isFrameworkMessage(controlMessage.messageId)) {
                            if (relatedControl.isInGrid && relatedControl.isInGrid() && relatedControl.Root && relatedControl.Root.UseReactGrid()) {
                                relatedControl.addMessage(controlMessage.messageId, controlMessage.text);
                            }
                            else {
                                relatedControl.addMessage(controlMessage.messageId);
                            }
                        }
                    }
                }
            };
            MessageBar.prototype.GetMessage = function (messageId) {
                var messageLists = [this.infoMessages, this.warningMessages, this.errorMessages];
                for (var i = 0, len = $dyn.length(messageLists); i < len; i++) {
                    var currentMessageList = $dyn.value(messageLists[i]);
                    // tslint:disable-next-line: prefer-for-of
                    for (var f = 0; f < currentMessageList.length; f++) {
                        if (currentMessageList[f].messageId === messageId) {
                            return currentMessageList[f];
                        }
                    }
                }
                return null;
            };
            MessageBar.prototype.AddMessage = function (newMessage) {
                this.AddMessages([newMessage]);
            };
            MessageBar.prototype.AddMessages = function (newMessageList) {
                var infos = [];
                var warns = [];
                var errors = [];
                for (var i = 0, len = $dyn.length(newMessageList); i < len; i++) {
                    switch (newMessageList[i].type) {
                        case $dyn.messaging.MessageType.information:
                            infos.push(newMessageList[i]);
                            break;
                        case $dyn.messaging.MessageType.warning:
                        case $dyn.messaging.MessageType.fieldValidation:
                        case $dyn.messaging.MessageType.controlValidation:
                            warns.push(newMessageList[i]);
                            break;
                        default:
                            errors.push(newMessageList[i]);
                            break;
                    }
                }
                // Please check function ClearInfoMessages if we ever add info message to control, i.e if we pass true as third parameter
                // to this.ProcessMessageList(this.infoMessages, infos, false);
                this.ProcessMessageList(this.infoMessages, infos, false);
                this.ProcessMessageList(this.warningMessages, warns, true);
                // Please check function ClearErrorMessages if we ever add info message to control, i.e if we pass true as third parameter
                // to this.ProcessMessageList(this.errorMessages, errors, false);
                this.ProcessMessageList(this.errorMessages, errors, false);
            };
            MessageBar.prototype.RemoveMessage = function (messageId) {
                var messageLists = [this.infoMessages, this.warningMessages, this.errorMessages];
                for (var i = 0, len = $dyn.length(messageLists); i < len; i++) {
                    var messages = messageLists[i];
                    if (messageId && messages) {
                        var currentMessageList = $dyn.value(messages).slice();
                        for (var f = 0, len2 = $dyn.length(currentMessageList); f < len2; f++) {
                            if (currentMessageList[f].messageId === messageId) {
                                currentMessageList.splice(f, 1);
                                break;
                            }
                        }
                        messages(currentMessageList);
                    }
                }
            };
            MessageBar.prototype.dispose = function () {
                $(document.body).off("clearMessageBarMessages", this.ClearMessages);
                $(document.body).off("removeMessages", this.RemoveMessages);
                _super.prototype.dispose.call(this);
            };
            MessageBar.prototype.TrimMessageList = function (messageList, numberToTrim) {
                if (numberToTrim > 0) {
                    if ($dyn.length(messageList) > 0) {
                        if ($dyn.length(messageList) > numberToTrim) {
                            var stopIndex = $dyn.length(messageList) - numberToTrim;
                            messageList(messageList().splice(0, stopIndex));
                        }
                        else {
                            messageList([]);
                        }
                    }
                }
            };
            MessageBar.prototype.ProcessMessageList = function (messageList, newMessages, addMessagesToControl) {
                if ($dyn.length(newMessages) > 0 && messageList) {
                    if (($dyn.length(newMessages) + $dyn.length(messageList)) > 500) {
                        var numberToTrim = ($dyn.length(newMessages) + $dyn.length(messageList)) - 500;
                        this.TrimMessageList(messageList, numberToTrim);
                    }
                    // reorder so the last message recieved is always shown first
                    var revNewMessageList = newMessages.reverse();
                    if ($dyn.length(messageList) > 0) {
                        var currentMessageList = $dyn.value(messageList).slice();
                        revNewMessageList = revNewMessageList.concat(currentMessageList);
                    }
                    // Do this first as adding to message bar fires adding message again, but if the message is added to control first, it will stop adding duplicate message.
                    if (addMessagesToControl) {
                        // Right now only warning messages go onto the related control
                        // If we want this logic to be control specific we should move the checks to the control level
                        for (var i = 0, len = $dyn.length(newMessages); i < len; i++) {
                            this._updateControl(revNewMessageList[i]);
                        }
                    }
                    // After adding to control, add message to message bar.
                    messageList(revNewMessageList);
                }
            };
            MessageBar.prototype.AddMessagesToList = function (list, messages) {
                for (var i = 0, len = $dyn.length(messages); i < len; i++) {
                    var message = messages[i];
                    list.push(message);
                }
            };
            MessageBar.prototype.MessagesToKeep = function (list) {
                var messagesToKeep = [];
                for (var i = 0, len = $dyn.length(list); i < len; i++) {
                    var message = list()[i];
                    if (message.messageId > 0) {
                        messagesToKeep.push(message);
                    }
                }
                return messagesToKeep;
            };
            return MessageBar;
        }($dyn.ui.Control));
        controls.MessageBar = MessageBar;
        $dyn.ui.addObservablePropertiesToPrototype(MessageBar.prototype, {
            ErrorExpanded: false,
            InfoExpanded: false,
            IsViewModeVisible: false,
            WarningExpanded: false
        });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=MessageBar.js.map
